(function () {
  "use strict";

  if (window.__bolodooWeddingDressFeeBinding) return;
  window.__bolodooWeddingDressFeeBinding = true;

  function getCartUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    return root.replace(/\/?$/, "/") + "cart.js";
  }

  function getUpdateUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    return root.replace(/\/?$/, "/") + "cart/update.js";
  }

  function getChangeUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    return root.replace(/\/?$/, "/") + "cart/change.js";
  }

  function getCheckoutUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
    return root.replace(/\/?$/, "/") + "checkout";
  }

  function getSections(source) {
    if (!source || typeof source.getSectionsToRender !== "function") return [];
    return source.getSectionsToRender().map(function (section) { return section.id; });
  }

  function getGroupValue(item) {
    if (!item || !item.properties) return "";
    return item.properties["_BND group"] || item.properties["_BND group ID"] || "";
  }

  function cleanInternalProperties(item) {
    var cleanedProperties = {};
    Object.keys((item && item.properties) || {}).forEach(function (key) {
      if (key.indexOf("_BND") !== 0) cleanedProperties[key] = item.properties[key];
    });
    return cleanedProperties;
  }

  function hasInternalProperties(item) {
    return Object.keys((item && item.properties) || {}).some(function (key) {
      return key.indexOf("_BND") === 0;
    });
  }

  function cleanInternalProperties(cart) {
    var items = (cart && cart.items) || [];
    return items.reduce(function (promise, item) {
      if (!hasInternalProperties(item)) return promise;
      return promise.then(function () {
        return fetch(getChangeUrl(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            line: item.key,
            quantity: item.quantity,
            properties: cleanInternalProperties(item)
          })
        }).then(function (response) {
          if (!response.ok) throw new Error("Unable to clean internal cart properties.");
          return response.json();
        });
      });
    }, Promise.resolve());
  }

  function getLineIndex(element) {
    var removeButton = element.closest("cart-remove-button");
    if (removeButton && removeButton.dataset.index) return Number(removeButton.dataset.index);

    var input = element.closest("quantity-input");
    if (input) {
      var inputElement = input.querySelector("[data-index]");
      if (inputElement && inputElement.dataset.index) return Number(inputElement.dataset.index);
    }

    var item = element.closest(".cart-item");
    var match = item && String(item.id || "").match(/-(\d+)$/);
    return match ? Number(match[1]) : 0;
  }

  function getRelatedUpdates(cart, lineIndex) {
    var item = cart && cart.items && cart.items[lineIndex - 1];
    if (!item) return null;
    var group = getGroupValue(item);
    var updates = {};
    if (!group) {
      updates[item.key] = 0;
    } else {
      (cart.items || []).forEach(function (line) {
        if (getGroupValue(line) === group) updates[line.key] = 0;
      });
    }
    return { item: item, updates: updates, group: group };
  }

  function removeBoundGroup(element) {
    var lineIndex = getLineIndex(element);
    if (!lineIndex) return Promise.resolve(false);

    var source = element.closest("cart-drawer, cart-items");
    return fetch(getCartUrl(), { headers: { Accept: "application/json" } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var relation = getRelatedUpdates(cart, lineIndex);
        if (!relation) return false;

        return fetch(getUpdateUrl(), {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          },
          body: JSON.stringify({
            updates: relation.updates,
            sections: getSections(source),
            sections_url: window.location.pathname
          })
        }).then(function (response) {
          return response.json().then(function (payload) {
            if (!response.ok) throw new Error(payload.description || "Unable to remove the selected item.");
            return { payload: payload, source: source };
          });
        });
      })
      .then(function (result) {
        if (result === false) return false;
        if (result.source && result.source.tagName.toLowerCase() === "cart-drawer" && typeof result.source.renderContents === "function" && result.payload.sections) {
          result.source.renderContents(result.payload);
        } else {
          window.location.reload();
        }
        document.dispatchEvent(new CustomEvent("cart:change", { bubbles: true, detail: result.payload }));
        return true;
      });
  }

  var checkoutPreparing = false;

  function prepareCheckout(event, destination) {
    if (checkoutPreparing) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    checkoutPreparing = true;
    fetch(getCartUrl(), { headers: { Accept: "application/json" } })
      .then(function (response) { return response.json(); })
      .then(cleanInternalProperties)
      .catch(function (error) {
        console.error("Unable to clean internal properties before checkout", error);
      })
      .then(function () {
        window.location.href = destination || getCheckoutUrl();
      });
  }

  document.addEventListener("click", function (event) {
    var control = event.target.closest && event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!control) return;
    prepareCheckout(event, control.tagName === "A" ? control.href : getCheckoutUrl());
  }, true);

  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.querySelector || !form.querySelector('[name="checkout"]')) return;
    prepareCheckout(event, getCheckoutUrl());
  }, true);

  document.addEventListener("click", function (event) {
    var remove = event.target.closest && event.target.closest("cart-remove-button a");
    var minus = event.target.closest && event.target.closest('button[name="minus"]');
    if (!remove && !minus) return;

    if (minus) {
      var input = minus.closest("quantity-input") && minus.closest("quantity-input").querySelector(".quantity__input");
      if (!input || Number(input.value) > 1) return;
    }

    var item = (remove || minus).closest(".cart-item");
    if (!item) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    removeBoundGroup(remove || minus).catch(function (error) {
      console.error("Unable to remove the bound wedding-dress fee group", error);
      window.location.reload();
    });
  }, true);

  document.addEventListener("change", function (event) {
    var input = event.target.closest && event.target.closest(".quantity__input");
    if (!input || Number(input.value) > 0) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    removeBoundGroup(input).catch(function (error) {
      console.error("Unable to remove the bound wedding-dress fee group", error);
      window.location.reload();
    });
  }, true);
})();
